import { h } from "preact";
import { useRef, useState, useEffect } from "preact/hooks";
import { Card } from "../../_common/layout";
import {
  FormFieldSelect,
  FormFieldTextArea,
  SubmitButtonRow,
} from "../../_common/forms/components/components";
import { Form as FinalForm } from "react-final-form";
import { toKeyName } from "../../_common/common.ts";
import { t } from "../../_i18n";

export default ({ documentType, onSubmit }) => {
  /** Variables **/
  const MAX_SIZE = 5 * 1024 * 1024;
  const ALLOWED_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const initialValues = {
    documentType: null,
    comment: null,
  };

  /** References **/
  const fileRef = useRef(null);
  const [fileError, setFileError] = useState(null);

  /** States **/
  const [file, setFile] = useState(null);
  const [documentOptions, setDocumentOptions] = useState([]);

  /** Lifecycles **/
  useEffect(() => {
    const noChildren = [];
    const withChildren = [];

    (documentType || []).forEach(type => {
      const parent = {
        id: type.id,
        name: type.name,
        disabled: !!type.children?.length,
      };

      if (type.children?.length) {
        withChildren.push(
          parent,
          ...type.children.map(child => ({
            id: child.id,
            name: child.name,
          }))
        );
      } else {
        noChildren.push(parent);
      }
    });

    const documentTypeWithChildren = [
      ...noChildren,
      ...withChildren,
    ];

    const formatedDocumentOptions = toKeyName(documentTypeWithChildren);
    setDocumentOptions(formatedDocumentOptions);
  }, [documentType]);

  /** Methods **/
  const handleClick = () => fileRef.current.click();

  const handleUploadFile = (e) => {
    const selected = e.target.files[0];

    if (!selected) {
      setFile(null);
      setFileError(null);
      return;
    }

    if (!ALLOWED_TYPES.includes(selected.type)) {
      setFile(null);
      setFileError(t('Solo se permiten archivos PDF o DOC/DOCX'));
      return;
    }

    if (selected.size > MAX_SIZE) {
      setFile(null);
      setFileError(t('El archivo no puede superar los 5 MB'));
      return;
    }

    setFileError(null);
    setFile(selected);
  };

  const handleMySubmit = async (data, form) => {
    return onSubmit?.({
      file,
      formData: data,
      reset: () => {
        form.reset();
        setFile(null);
        setFileError(null);
        if (fileRef.current) {
          fileRef.current.value = "";
        }
      },
    });
  };

  /** Render **/
  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={handleMySubmit}
      render={({ handleSubmit, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Card smOnly={false}>
            <div className="flex flex-col gap-3 rounded-lg py-3">
              {/* Archivo */}
              <div>
                <p className="mb-1 font-bold">{t('Archivo')}</p>
                <div
                  onClick={handleClick}
                  className="hover:bg-info-50 cursor-pointer border border-dashed border-gray-300 p-6 text-center"
                >
                  {file ? (
                    file.name
                  ) : (
                    <span className="font-bold">
                      <i className="fa fa-upload" /> {t('Seleccionar archivo')}
                    </span>
                  )}
                </div>
                <input
                  ref={fileRef}
                  type="file"
                  className="hidden"
                  onChange={handleUploadFile}
                />

                <p className="mt-2 text-xs">
                  {fileError ? (
                    <span className="text-error-600">{fileError}</span>
                  ) : (
                    file ? null : t('PDF o DOC (máx. 5 MB)')
                  )}
                </p>
              </div>
              {/* Tipo de documento */}
              <FormFieldSelect
                name="documentType"
                label={t('Tipo de documento')}
                specificError={t('Este campo es obligatorio')}
                required
                options={documentOptions}
              />
              {/* Comentario */}
              <FormFieldTextArea name="comment" label={t('Comentario')} />
              {/* Enviar docuentos */}
              <div className="flex justify-end">
                <SubmitButtonRow
                  className="-mb-2 -mt-6"
                  disabled={submitting || pristine || !file  || !values.documentType}
                >
                  {t('Enviar documentos')}
                </SubmitButtonRow>
              </div>
            </div>
          </Card>
        </form>
      )}
    />
  );
};
